// extracted by mini-css-extract-plugin
export default {"result-div":"ResultSection_result-div__p0uoa","thumb-div":"ResultSection_thumb-div__xgdoS","download-section":"ResultSection_download-section__OJbi7"};